'use strict';

var Navs = function(config) {

  var self = this;
  var $navs = $(config.navs);
  var $show = $(config.show);
  var $hide = $(config.hide);
  var $html = $('html');
  var $body = $('body');

  self.clickHandler = function($button, cb) {
    $button.on('click.mainHeaderNavs', function() {

      if (typeof cb === 'function') {
        cb();
      }
    });
  }

  self.showNavs = function() {

    if (! $navs.hasClass('is-visible') && ! $navs.hasClass('velocity-animating')) {

      $html.addClass('main-header-navs-open');
      $navs
        .addClass('is-visible')
        .velocity({
          translateY: [0, '-100%']
        },{
          easing: 'easeOutQuart',
          complete: function() {
            $body.addClass('no-scroll');
          }
        });
    }
  }

  self.hideNavs = function() {

    if ($navs.hasClass('is-visible') && ! $navs.hasClass('velocity-animating')) {

      $html.removeClass('main-header-navs-open');
      $navs
        .removeClass('is-visible')
        .velocity({
          translateY: ['-100%', 0]
        },{
          easing: 'easeOutQuart',
          complete: function() {
            $body.removeClass('no-scroll');
          }
        });
    }
  }

  self.destroy = function() {
    $html.removeClass('main-header-navs-open');
    $body.removeClass('no-scroll');
    $navs
      .removeClass('is-visible velocity-animating')
      .removeAttr('style');
    $show.off('click.mainHeaderNavs');
    $hide.off('click.mainHeaderNavs');
  }

  self.init = function() {
    self.clickHandler($show, self.showNavs);
    self.clickHandler($hide, self.hideNavs);
  }
};

module.exports = Navs;
